import React, { useEffect } from "react";
import IndexButtons from "./IndexButtons";
import FOG from "vanta/dist/vanta.fog.min";
import * as THREE from "three";
import { Navigate } from "ellipse/navigate/Navigate";

export interface IndexMainAreaProps {}

const IndexMainArea: React.FC<IndexMainAreaProps> = (props: IndexMainAreaProps) => {

	const startBackground = () => {
		if (Navigate.isUnitTest()) {
			return;
		}
		FOG({
			el: "#indexmainarea-background",
			THREE,
			mouseControls: true,
			touchControls: true,
			gyroControls: false,
			minHeight: 200.0,
			minWidth: 200.0,
			highlightColor: 0xbfcfe8,
			midtoneColor: 0x375081,
			lowlightColor: 0x375081,
			baseColor: 0x375081,
			blurFactor: 0.21,
			speed: 0.8,
			zoom: 0.6,
		});
	};

	useEffect(() => {
		try {
			startBackground();
		} catch (e) {}
	}, []);

	return (
		<div id="indexmainarea-background" className="md:min-h-screen flex items-center justify-center md:sticky top-0 left-0 lg:min-w-[36rem]">
			<div id="indexmainarea-container" className="flex flex-col items-start space-y-4 p-8 pb-16 ">
				<div id="indexmainarea-header" className="flex items-center space-x-2 pb-4">
					<img id="indexmainarea-logo" src="images/indexmainarea_000009.png" alt="Combined Platforms Logo" />
				</div>
				<div id="indexmainarea-news" className="flex items-center space-x-2 hidden">
					<span id="indexmainarea-badge" className="px-2 py-1 border rounded-full cursor-pointer min-w-[5.25rem]">
						What&apos;s new
					</span>
					<span id="indexmainarea-news-text" className="cursor-pointer">
						Introducing Design Shift - AI assisted conversion of SVG files
					</span>
				</div>
				<h1 id="indexmainarea-main-text" className="leading-tight">
					SaaS.
					<br />
					Executed
					<br className="hidden md:block lg:hidden" /> efficiently.
				</h1>
				<p id="indexmainarea-description" className="md:w-96">
					Combined Platforms uses cutting edge AI-driven techniques to efficiently design, build and operate functional SaaS platforms.
				</p>
				<IndexButtons />
			</div>
		</div>
	);

};

export default IndexMainArea;